var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none"}},_vm.$listeners),[_c('path',{attrs:{"fill":"#1D1B1E","d":"M21 11V3h-8l3.29 3.29-10 10L3 13v8h8l-3.29-3.29 10-10z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }